import {
  Page,
  Text,
  Link,
  Document,
  StyleSheet,
  Font,
} from "@react-pdf/renderer";

import Play from "./Play.jsx";

import PublicSansRegular from "../../fonts/Public_Sans/PublicSans-Regular.ttf";
import PublicSansBold from "../../fonts/Public_Sans/PublicSans-Bold.ttf";
import PublicSansItalic from "../../fonts/Public_Sans/PublicSans-Italic.ttf";
import PublicSansBoldItalic from "../../fonts/Public_Sans/PublicSans-BoldItalic.ttf";

import NotoSansRegular from "../../fonts/Noto_Sans/static/NotoSans-Regular.ttf";
import NotoSansBold from "../../fonts/Noto_Sans/static/NotoSans-Bold.ttf";
import NotoSansItalic from "../../fonts/Noto_Sans/static/NotoSans-Italic.ttf";
import NotoSansBoldItalic from "../../fonts/Noto_Sans/static/NotoSans-BoldItalic.ttf";

import NotoSansArabicRegular from "../../fonts/Noto_Sans_Arabic/static/NotoSansArabic-Regular.ttf";
import NotoSansArabicBold from "../../fonts/Noto_Sans_Arabic/static/NotoSansArabic-Bold.ttf";

/*
import NotoSansJPRegular from "../../fonts/Noto_Sans_JP/static/NotoSansJP-Regular.ttf";
import NotoSansJPBold from "../../fonts/Noto_Sans_JP/static/NotoSansJP-Bold.ttf";

import NotoSansKRRegular from "../../fonts/Noto_Sans_KR/static/NotoSansKR-Regular.ttf";
import NotoSansKRBold from "../../fonts/Noto_Sans_KR/static/NotoSansKR-Bold.ttf";
*/
import RobotoRegular from "../../fonts/Roboto/Roboto-Regular.ttf";
import RobotoBold from "../../fonts/Roboto/Roboto-Bold.ttf";
import ArialBold from "../../fonts/Arial/Arial_Bold.ttf";
import { pdfFont } from "./utils.js";

const stylesheet = (fontSize) => ({
  // clear margins for all <p> tags
  "*": {
    fontFamily: pdfFont,
    fontSize: fontSize,
  },
  "p,ol,ul,pre,blockquote,h1,h2,h3,h4,h5,h6": {
    margin: 0,
    padding: 0,
  },
  ".ql-indent-1": {
    paddingLeft: fontSize * 1,
  },
  ".ql-indent-2": {
    paddingLeft: fontSize * 4,
  },
  ".ql-indent-3": {
    paddingLeft: fontSize * 6,
  },
  ".ql-indent-4": {
    paddingLeft: fontSize * 8,
  },
  ".ql-indent-5": {
    paddingLeft: fontSize * 10,
  },
  ".ql-indent-6": {
    paddingLeft: fontSize * 12,
  },
  ".ql-indent-7": {
    paddingLeft: fontSize * 14,
  },
  "ol,ul": {
    paddingLeft: 0,
    margin: 0,
  },
  li: {
    marginLeft: -15,
    marginBottom: 5,
  },
});

export default function PlayPDF(props) {
  let pixelPerInch = 600 / 8.27;
  //max Height is important to avoid a single phase being so big that it doesnt fit onto a page which would
  //result in an infinite loop in the pdf wrapping algorithm

  let { printSettings, phases, court, title, description } = props;
  let {
    cols,
    courtColor,
    pagePadding,
    printPlayDescriptions,
    printPhaseDescriptions,
    printPhaseTitles,
    fontSizes,
    objectSizeFactor,
    showLink = true,
  } = printSettings;

  let horizontalPadding = Math.min(pagePadding.horizontal, 2);
  let verticalPadding = Math.min(pagePadding.vertical, 1.5);
  let pageWidth = 595;
  let paddingWidth = (horizontalPadding / 8.3) * pageWidth;
  let framePadding = 10;
  let frameWidth =
    (pageWidth - 2 * paddingWidth + framePadding) / cols - framePadding;

  let styles = stylesGenerator(pagePadding);

  let maxHeight = 700 - 2 * pixelPerInch * verticalPadding;

  return (
    <Document>
      <Page key={0} size="A4" style={styles.page}>
        <Play
          cols={cols}
          court={court}
          courtColor={courtColor}
          description={description}
          fontSizes={fontSizes}
          framePadding={framePadding}
          frameWidth={frameWidth}
          maxHeight={maxHeight}
          objectSizeFactor={objectSizeFactor}
          pageWidth={pageWidth}
          paddingWidth={paddingWidth}
          phases={phases}
          printPhaseDescriptions={printPhaseDescriptions}
          printPhaseTitles={printPhaseTitles}
          printPlayDescriptions={printPlayDescriptions}
          stylesheet={stylesheet}
          title={title}
        />

        <Text
          style={{
            position: "absolute",
            fontSize: 8,
            bottom: 35,
            left: 0,
            right: 0,
            textAlign: "center",
            color: "grey",
            fontFamily: pdfFont,
          }}
          render={({ pageNumber, totalPages }) =>
            `${pageNumber} / ${totalPages}`
          }
          fixed
        />
        {showLink && (
          <Text
            style={{
              position: "absolute",
              fontSize: 8,
              bottom: 20,
              left: 0,
              right: 20,
              textAlign: "center",
              color: "#333",
              fontFamily: pdfFont,
            }}
            fixed
          >
            Created using{" "}
            <Link
              src={
                "https://www.thehoopsgeek.com/playcreator/?utm_source=PlayCreator&utm_medium=PDF&utm_campaign=PDF"
              }
            >
              <Text>www.thehoopsgeek.com/playcreator/</Text>
            </Link>
          </Text>
        )}
      </Page>
    </Document>
  );
}

// Font.register({
//   family: "Public Sans",
//   fonts: [
//     {
//       src: PublicSansRegular,
//     },
//     {
//       src: PublicSansBold,
//       fontWeight: "bold",
//     },
//     {
//       src: PublicSansItalic,
//       fontStyle: "italic",
//     },
//     {
//       src: PublicSansBoldItalic,
//       fontStyle: "italic",
//       fontWeight: "bold",
//     },
//   ],
// });

// Font.register({
//   family: "Noto Sans",
//   fonts: [
//     {
//       src: NotoSansRegular,
//     },
//     {
//       src: NotoSansBold,
//       fontWeight: "bold",
//     },
//     {
//       src: NotoSansItalic,
//       fontStyle: "italic",
//     },
//     {
//       src: NotoSansBoldItalic,
//       fontStyle: "italic",
//       fontWeight: "bold",
//     },
//   ],
// });

// Font.register({
//   family: "Noto Sans Arabic",
//   fonts: [
//     {
//       src: NotoSansArabicRegular,
//     },
//     {
//       src: NotoSansArabicBold,
//       fontWeight: "bold",
//     },
//     {
//       src: NotoSansArabicRegular,
//       fontStyle: "italic",
//     },
//     {
//       src: NotoSansArabicBold,
//       fontStyle: "italic",
//       fontWeight: "bold",
//     },
//   ],
// });

// /*
// Font.register({
//   family: "Noto Sans JP",
//   fonts: [
//     {
//       src: NotoSansJPRegular,
//     },
//     {
//       src: NotoSansJPBold,
//       fontWeight: "bold",
//     },
//     {
//       src: NotoSansJPRegular,
//       fontStyle: "italic",
//     },
//     {
//       src: NotoSansJPBold,
//       fontStyle: "italic",
//       fontWeight: "bold",
//     },
//   ],
// });

// Font.register({
//   family: "Noto Sans KR",
//   fonts: [
//     {
//       src: NotoSansKRRegular,
//     },
//     {
//       src: NotoSansKRBold,
//       fontWeight: "bold",
//     },
//     {
//       src: NotoSansKRRegular,
//       fontStyle: "italic",
//     },
//     {
//       src: NotoSansKRBold,
//       fontStyle: "italic",
//       fontWeight: "bold",
//     },
//   ],
// });
// */
// Font.register({
//   family: "Roboto",
//   fonts: [
//     {
//       src: RobotoRegular,
//     },
//     {
//       src: RobotoBold,
//       fontWeight: "bold",
//     },
//   ],
// });

// Font.register({
//   family: "Arial",
//   fonts: [
//     {
//       src: ArialBold,
//       fontWeight: "bold",
//     }, // font-style: normal, font-weight: normal
//   ],
// });

const stylesGenerator = (pagePadding) => {
  let horizontalPadding = Math.min(pagePadding.horizontal, 2);
  let verticalPadding = Math.min(pagePadding.vertical, 1.5);
  return StyleSheet.create({
    page: {
      fontSize: 12,
      fontFamily: "Public Sans",
      padding: `${verticalPadding}in ${horizontalPadding}in`,
      backgroundColor: "#ffffff",
      border: "1px solid #ccc",
    },
  });
};
